<template>
  <div id="footer" class="container-fluid">
    <!-- Logo -->
    <!--    <div class="footer-logos">-->
    <!--      <div class="footer-logo">-->
    <!--        <img :src="items.data.logoButtom" alt="公司Logo" class="logo-img" />-->
    <!--      </div>-->
    <!--      <div class="footer-logo">-->
    <!--        <img src="@/assets/img/wx.jpg" alt="公司Logo" class="logo-img" />-->
    <!--      </div>-->
    <!--    </div>-->


    <!-- 主要内容区域 -->
    <div class="footer-content">
      <!-- 左侧导航菜单 -->
      <div class="footer-nav">
        <div class="footer-logo">
          <img :src="items.data.logoButtom" alt="公司Logo" class="logo-img" />
        </div>
        <h4 data-i18n="homePage_site">网站导航</h4>
        <ul>
          <li v-for="(item, index) in navList" :key="index">
            <router-link
              :data-i18n="item.language"
              :to="item.path"
            >{{ item.name }}</router-link
            >
          </li>
        </ul>
      </div>

      <!-- 右侧联系信息 -->
      <div class="footer-contact">
        <div class="footer-logo">
          <img src="../assets/img/wx.jpg" alt="二维码" class="logo-img" />
        </div>
        <h4 data-i18n="homePage_us">联系我们</h4>
        <p class="company-name">
          {{ items.data.companyName[lang] || items.data.companyName }}
        </p>
        <p class="contact-item">
          <img class="icon" src="../assets/img/address.png" alt="">
          <span>{{ items.data.address[lang] || items.data.address }}</span>
        </p>
        <p class="contact-item">
          <img class="icon" src="../assets/img/phone.png" alt="">
          <span>{{ items.data.phone }}</span>
        </p>
        <p class="contact-item">
          <img class="icon" src="../assets/img/email.png" alt="">
          <span>{{ items.data.mail }}</span>
        </p>
      </div>
    </div>
    <!-- 版权信息 -->
    <!-- 版权信息 -->
    <div class="footer-copyright">
      <p>
        Copyright &copy; {{ new Date().getFullYear() }} 山东鑫华技术有限公司 版权所有
        <span class="separator">|</span>
        <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">
          鲁ICP备2024123901号
        </a>
      </p>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { websiteUrl, fileUrl } from "../../url.js";
// 引入翻译变量
import { sharedState } from "../assets/js/languages/fanyi";
import { translatePage } from "../assets/js/languages/change_language";

export default {
  name: "Footer",
  data() {
    return {
      items: {},
      navList: [
        { name: "首页1", path: "/home",language: "home_home", },
        { name: "智能化解决方案", path: "/service",language: "home_service", },
        { name: "产品中心", path: "/product/center",language: "home_product", },
        { name: "成功案例", path: "/product/success",language: "home_success", },
        // { name: "技术支持", path: "/contactus" },
        { name: "新闻中心", path: "/newsinformation",language: "home_news", },
        { name: "关于我们", path: "/companyintroduction",language: "home_about", },
      ],
    };
  },
  mounted() {
    this.getFooter();
    translatePage();
  },
  // 语言变量 计算属性
  computed: {
    lang() {
      return sharedState.lang;
    },
  },
  methods: {
    async getFooter() {
      const cache = localStorage.getItem("footerData");
      if (cache) {
        this.items = JSON.parse(cache);
      }
      try {
        const response = await axios.get(
          `${websiteUrl}/mes-official-website-manage/homepage/getInfo/1`
        );
        const data = response.data.data;

        if (typeof data.companyName === "string") {
          data.companyName = JSON.parse(data.companyName);
        }
        if (typeof data.address === "string") {
          data.address = JSON.parse(data.address);
        }

        data.logoTop = fileUrl + data.logoTop;
        data.logoButtom = fileUrl + data.logoButtom;
        this.items = response.data;
        localStorage.setItem("footerData", JSON.stringify(this.items));
      } catch (error) {
        console.error("获取数据失败:", error);
      }
    },
  },
};
</script>

<style scoped>
/* 变量定义 */
:root {
  --footer-bg: #474747;
  --text-primary: #fff;
  --text-secondary: #d3d3d3;
  --text-muted: #999;
  --divider-color: #666;
  --hover-transition: all 0.3s ease;
}

#footer {
  background: #474747;
  color: #fff;
  padding: clamp(2rem, 5vw, 3.5rem) 0 1.25rem;
  font-family: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue",
  sans-serif;
  line-height: 1.6;
}

/* Logo样式 - 使用aspect-ratio保持比例 */
.footer-logos {
  display: flex;
  justify-content: center;  /* 水平居中，可按需调整 */
  align-items: center;
  gap: 2rem;                /* 两个logo之间的间距 */
  max-width: 1200px;
  margin: 0 auto 2rem;
  padding: 0 1rem;
  flex-wrap: wrap;          /* 小屏幕时自动换行 */
}
.footer-logo {
  margin-bottom: 1rem;  /* 与下方标题保持间距 */
  text-align: left;     /* 左对齐（可根据设计调整） */
}

.logo-img {
  height: 80px;         /* 可根据需要调整大小 */
  width: auto;
  object-fit: contain;
  /* filter: brightness(0) invert(1); 使logo在深色背景上更清晰 */
}

/* 主要内容区域 - 使用CSS Grid实现更灵活的布局 */
.footer-content {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1rem;
}

/* 导航菜单 - 使用column-count实现多列布局 */
.footer-nav {
  position: relative;
}

.footer-nav h4 {
  font-size: 15px;
  margin-bottom: 1.25rem;
  color: #fff;
  padding-bottom: 0.625rem;
  border-bottom: 1px solid #666;
}

.footer-nav ul {
  columns: 2;
  column-gap: 2rem;
  padding: 0;
  margin: 0;
  list-style: none;
}

.footer-nav li {
  break-inside: avoid;
  margin-bottom: 0.75rem;
}

.footer-nav a {
  color: #d3d3d3;
  text-decoration: none;
  transition: all 0.3s ease;
  display: inline-block;
  padding: 0.25rem 0;
}

.footer-nav a:hover,
.footer-nav a:focus {
  color: #fff;
  transform: translateX(3px);
}

/* 联系信息 - 使用CSS Grid布局图标和文本 */
.footer-contact {
  position: relative;
}

.footer-contact h4 {
  font-size: 15px;
  margin-bottom: 1.25rem;
  color: #fff;
  padding-bottom: 0.625rem;
  border-bottom: 1px solid #666;
}

.company-name {
  font-weight: 600;
  margin-bottom: 1rem;
  color: #fff;
}

.contact-item {
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 0.75rem;
  align-items: center;
  color: #d3d3d3;
  margin-bottom: 0.75rem;
}

.contact-item .icon {
  font-size: 1rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
}

/* 版权信息 - 添加微妙的顶部边框渐变 */
.footer-copyright {
  text-align: center;
  margin-top: 2.5rem;
  padding-top: 1.25rem;
  color: #999;
  font-size: 1.2rem;
  position: relative;
}

.footer-copyright::before {
  content: "";
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: min(90%, 1000px);
  height: 1px;
  background: linear-gradient(90deg, transparent, #666, transparent);
}

/* 分隔符样式 */
.footer-copyright .separator {
  margin: 0 0.75rem;
  color: #666;
}

/* ICP备案号样式 - 移除独立样式，合并到p标签内 */
.footer-copyright a {
  color: #999;
  text-decoration: none;
  transition: all 0.3s ease;
}

.footer-copyright a:hover {
  color: #fff;
  text-decoration: underline;
}

/* 响应式设计 - 使用媒体查询和clamp()函数 */
@media screen and (max-width: 768px) {
  .footer-nav ul {
    columns: 1;
  }

  .footer-content {
    grid-template-columns: 1fr;
    gap: 2.5rem;
  }

  .footer-contact {
    padding-top: 2rem;
  }

  .footer-contact::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 1px;
    background: #666;
  }
}

/* 打印样式 */
@media print {
  #footer {
    background: none;
    color: #000;
    padding: 1rem 0;
  }

  .logo-img {
    filter: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue